import { render, staticRenderFns } from "./dropzone-section.vue?vue&type=template&id=af53691c"
import script from "./dropzone-section.vue?vue&type=script&lang=js"
export * from "./dropzone-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports